<template>
    <div  v-loading.fullscreen.lock.body="loading"
          element-loading-text="拼命加载中"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.7)">
        <el-row style="height: 40px;line-height: 40px;">
            <el-col>
                <span style="font-weight: bold;margin-right: 10px">月份</span>
<!--                <el-date-picker-->
<!--                        v-model="month"-->
<!--                        type="month"-->
<!--                        placeholder="选择月"-->
<!--                        format="yyyy年MM月"-->
<!--                        value-format="yyyy-MM">-->
<!--                </el-date-picker>-->
                <reportMonth :handleSelectInput="handleSelectInput"></reportMonth>
                <div style="float: right" v-if="this.role!='staff'">
                    <span style="font-size: 16px;font-weight: bold;margin-right: 10px;">辖区</span>
                    <popedom :handleSelectInput="handleSelectInputClick" :shelfData="shelfData"></popedom>
                </div>
            </el-col>
        </el-row>
        <el-row style="margin-top: 20px">
            <el-col style="display: flex;justify-content: space-between">
                <el-col span="6">
                    <el-button style="background: #4EC880;border:none;color: #fff" size="small" @click="select()">查询</el-button>
                    <el-button style="background: #D0021B;border:none;color: #fff" size="small" @click="ResetClick">重置</el-button>
                </el-col>
                <el-col span="5" style="display: flex;justify-content:flex-end">
                    <el-button style="background: #FF9901;border:none;color: white" size="small" icon="el-icon-upload2" @click="exportDetailClick">导出明细</el-button>
                    <el-button style="background: #4A90E2;border:none;color: white;margin-left: 20px" size="small" icon="el-icon-upload2" @click="exportClick">导出报表</el-button>
                </el-col>
            </el-col>
            <el-col style="border-bottom: 2px dotted rgb(231, 234, 236);margin-top: 20px"></el-col>
        </el-row>
        <div>
            <el-row style="margin-top: 15px;">
                <el-col style="font-weight: bold;font-size: 22px">{{yearsDate}}</el-col>
                <el-col style="display: flex;justify-content: flex-start">
                    <el-col span="12">
                        <el-col style="margin-top: 20px;" id="progress">
                            <el-col :span="6">
                                <span style="font-size: 14px;color: #909399">签到总次数</span>
                            </el-col>
                            <el-col :span="16">
                            <span style="width: 220px;display: inline-block;position: relative;top: -1px">
                                <el-progress :text-inside="true" :show-text="false" color="#20C468" :stroke-width="20" :percentage="checkPercent"></el-progress>
                            </span>
                                <span style="color:#FF9901;height: 20px;line-height: 13px;margin-left: 5px;font-size: 13px;font-weight: bold;position: relative;top: -5px">{{checkin}}次</span>
                                <p style="margin:0 0 0 60px;font-size: 9px;color: #4A90E2;">GPS签到{{checkin_gps}}次，手动签到{{checkin_hand}}次</p>
                            </el-col>
                        </el-col>

                        <el-col style="margin-top: 10px;" id="rate">
                            <el-col :span="6">
                                <span style="font-size: 14px;color: #909399">有签入无签出</span>
                            </el-col>
                            <el-col :span="18" style="display: flex;justify-content:flex-start;position:relative;top: -2px">
                            <span style="width: 220px;display: inline-block">
                                 <el-rate
                                         low-threshold="10"
                                         high-threshold="10"
                                         style="float: left;margin-bottom: 5px"
                                         disabled
                                         v-model="gridPercentage"
                                         :max="max"
                                         disabled-void-color="#9B9B9B"
                                         disabled-void-icon-class="iconfont icon-shixinzhengfangxing"
                                         :iconClasses="iconClasses"
                                         void-color="#FF9901"
                                         void-icon-class="iconfont_Add icon-shixinzhengfangxing"
                                         :colors="colors"
                                 >
                                </el-rate>
                            </span>
                                <span style="color:#FF9901;line-height: 25px;font-weight: bold;font-size:13px;margin-left: 10px">{{percentage}}%（{{inOut}}次）</span>
                            </el-col>
                        </el-col>

                        <el-col style="margin-top: 20px;">
                            <el-col :span="6">
                                <span style="font-size: 14px;color: #909399">拜访总时长</span>
                            </el-col>
                            <el-col :span="17">
                                <span style="color:#9B9B9B;float: left;font-size: 16px;font-weight: bold">{{in_field}}小时</span>
                            </el-col>
                        </el-col>
                        <el-col style="color: #6fa7e8;font-size: 18px;font-weight: bold; margin: 60px 0 0 0;text-align: center">
                            数据汇总
                        </el-col>
                    </el-col>
                    <div style="height: 100px;width: 2px;background: #9fa5ac;margin: 20px 0"></div>
                    <el-col :span="14">
                      <el-col :span="24" id="scatter" style="height: 180px">
                        </el-col>
                      <el-col style="color: #6fa7e8;font-size: 18px;font-weight: bold; margin: 5px 0 0 0;text-align: center">
                          各时间段签入次数情况
                         </el-col>
                    </el-col>
                </el-col>
            </el-row>

        </div>
        <el-table
                :data="tableData"
                style="width: 100%;margin-top:20px"
        >
            <el-table-column
                    align="center"
                    width="60"
                    type="index"
                    label="序号"
                    sortable>
            </el-table-column>
            <el-table-column
                    v-if="this.isEndPoint"
                    label="辖区" sortable>
                <template slot-scope="scope">
                    {{scope.row.territory_name}}{{scope.row.staff_name?'('+scope.row.staff_name+')':''}}
                </template>
            </el-table-column>
            <el-table-column
                    v-if="!this.isEndPoint"
                    label="下级辖区"
                    sortable>
                <template slot-scope="scope">
                    {{scope.row.territory_name}}{{scope.row.staff_name?'('+scope.row.staff_name+')':''}}
                </template>
            </el-table-column>
            <el-table-column
                    v-if="this.isEndPoint"
                    prop="reference_name"
                    label="客户名称"
                     sortable>
            </el-table-column>
            <el-table-column
                    align="center"
                    width="120"
                    prop="checkin"
                    label="签到次数" sortable>
            </el-table-column>
            <el-table-column
                    align="center"
                    width="130"
                    prop="checkin_gps"
                    label="GPS签到次数" sortable>
            </el-table-column>
            <el-table-column
                    align="center"
                    width="130"
                    prop="checkin_hand"
                    label="手动签到次数" sortable>
            </el-table-column>
            <el-table-column
                    align="center"
                    width="120"
                    prop="visitTime"
                    label="拜访总时长" sortable>
            </el-table-column>
            <el-table-column
                    align="center"
                    width="150"
                    prop="averageTime"
                    label="平均拜访总时长" sortable>
            </el-table-column>
        </el-table>
<!--        <el-table-->
<!--                :data="tableData"-->
<!--                style="width: 100%;margin-top: 20px"-->
<!--                v-if="(this.role=='manager'||this.role=='admin')&&!this.isEndPoint"-->
<!--        >-->
<!--            <el-table-column-->
<!--                    align="center"-->
<!--                    type="index"-->
<!--                    label="序号"-->
<!--                    sortable>-->
<!--            </el-table-column>-->
<!--            <el-table-column-->
<!--                    label="下级辖区"-->
<!--                    sortable>-->
<!--                <template slot-scope="scope">-->
<!--                    {{scope.row.territory_name}}{{scope.row.staff_name?'('+scope.row.staff_name+')':''}}-->
<!--                </template>-->
<!--            </el-table-column>-->
<!--            <el-table-column-->
<!--                    width="120"-->
<!--                    prop="checkin"-->
<!--                    label="签到次数" sortable>-->
<!--            </el-table-column>-->
<!--            <el-table-column-->
<!--                    width="130"-->
<!--                    prop="checkin_gps"-->
<!--                    label="GPS签到次数" sortable>-->
<!--            </el-table-column>-->
<!--            <el-table-column-->
<!--                    width="130"-->
<!--                    prop="checkin_hand"-->
<!--                    label="手动签到次数" sortable>-->
<!--            </el-table-column>-->
<!--            <el-table-column-->
<!--                    width="130"-->
<!--                    prop="visitTime"-->
<!--                    label="拜访总时长" sortable>-->
<!--            </el-table-column>-->
<!--            <el-table-column-->
<!--                    width="150"-->
<!--                    prop="averageTime"-->
<!--                    label="平均拜访总时长" sortable>-->
<!--            </el-table-column>-->
<!--        </el-table>-->
    </div>

</template>

<script>
    import popedom from "../popedom"
    import reportMonth from '../reportMonth'
    import http from '../../../../APIService/http'
    import moment from 'moment'
    export default {
        name: "index",
        data(){
            return{
                month:'',
                role:'',
                yearsDate:'',
                date:'',
                value1:4,
                value4: 7.5,
                iconClasses: ['iconfont icon-shixinzhengfangxing', 'iconfont icon-shixinzhengfangxing',
                    'iconfont icon-shixinzhengfangxing',
                    'iconfont icon-shixinzhengfangxing', 'iconfont icon-shixinzhengfangxing',
                    'iconfont icon-shixinzhengfangxing',
                    'iconfont icon-shixinzhengfangxing', 'iconfont icon-shixinzhengfangxing',
                    'iconfont icon-shixinzhengfangxing',
                    'iconfont icon-shixinzhengfangxing'],
                colors:['#FF9901','#FF9901','#FF9901'],
                max:10,
                scatterDom:'',
                checkinCount:[],
                checkin:'',
                checkin_gps:'',
                checkin_hand:'',
                percentage:'',
                gridPercentage:'',
                in_field:0,
                inOut:'',
                checkPercent:0,
                tableData:[],
                loading:false,
                isEndPoint:false
            }
        },
        components:{
            popedom,
            reportMonth
        },
        methods:{
            async select(){
                this.yearsDate=moment(this.GLOBAL.date).format('YYYY年M月')
                this.getCheckinCount()
                this.getSignInfo()
                this.getAllCount()
            },
            scatter(){
                this.scatterDom = this.$echarts.init(document.getElementById('scatter'));
                this.scatterDom.setOption({
                    grid: {
                        top: '10',
                        bottom: '60',
                    },
                    xAxis: {
                        type: 'category',
                        nameGap: 16,
                        nameTextStyle: {
                            color: '#909399',
                            fontSize: 14,

                        },
                        data: ['','8点之前', '9点', '10点', '11点', '12点', '13点', '14点', '15点', '16点', '17点', '18点', '19点及以后',''],
                        splitLine: {
                            show: false
                        },
                        axisLine: {
                            lineStyle: {
                                color: '#E3EEF9',
                                width: 10,
                            }
                        },
                        axisLabel: {
                            show: true,
                            textStyle: {
                                color: '#909399',
                            },
                            interval: 0,
                            rotate: 30,
                            padding: [0, 20]
                        }
                    },
                    array:[],
                    yAxis: {
                        type: 'value',
                        nameLocation: 'end',
                        show: false,
                        nameGap: 20,
                        nameTextStyle: {
                            color: '#fff',
                            fontSize: 16
                        },
                        axisLine: {
                            lineStyle: {
                                color: '#eee'
                            }
                        },
                        splitLine: {
                            show: false
                        }
                    },
                    visualMap: [
                        {
                            dimension: 1,
                            min: 0,
                            max: 100,
                            show: false,
                            textStyle: {
                                color: '#fff'
                            },
                            inRange: {
                                symbolSize: [10, 40],

                            },
                        },
                        {
                            dimension: 2,
                            min: 0,
                            max: 60,
                            show: false,
                            splitNumber: 2,
                            color: ['#ffcc80', '#a5c8f1'],
                            textStyle: {
                                color: '#fff'
                            },

                        }
                    ],
                    series: [
                        {
                            type: 'scatter',
                            data: this.checkinCount,
                            label: {
                                show: true,
                            },
                        },
                    ]
                })
            },
            async getCheckinCount(){
                // let loading = this.$loading({
                //     lock: true,
                //     text: '拼命加载中',
                //     spinner: 'el-icon-loading',
                //     background: 'rgba(0, 0, 0, 0.7)'
                // });
                this.loading = true
                try{
                    let data={
                        role:this.role,
                        month:moment(this.GLOBAL.date).format('YYYY-MM'),
                        user_id:this.$store.getters.getUser.user_id,
                        tenant_id:this.$store.getters.getUser.tenant_id,
                        territory_id:this.GLOBAL.territory_id,
                    }
                    await http.post('/wapi/v1/getCheckinCount',data).then(res=>{
                        if(res.success){
                            this.checkinCount=res.data
                            //console.log(res.data)
                            this.scatter()
                        }else{
                            this.loading = false
                        }
                    })

                }catch (e) {
                    this.loading = false
                }
            },
            async getSignInfo(){
                // let loading = this.$loading({
                //     lock: true,
                //     text: '拼命加载中',
                //     spinner: 'el-icon-loading',
                //     background: 'rgba(0, 0, 0, 0.7)'
                // });
                try{

                    let data={
                        role:this.role,
                        month:moment(this.GLOBAL.date).format('YYYY-MM'),
                        user_id:this.$store.getters.getUser.user_id,
                        tenant_id:this.$store.getters.getUser.tenant_id,
                        territory_id:this.GLOBAL.territory_id,
                    }
                    await http.post('/wapi/v1/getSignInfo',data).then(res=>{
                        // console.log(res.data,666)
                        if(res.success){
                            this.tableData = res.data.list
                            this.isEndPoint = res.data.type ==='ENDPOINT'?true:false
                            this.loading = false
                        }else {
                            this.loading = false
                        }
                    })
                }catch (e) {
                    this.loading = false
                }
            },
            async getAllCount(){
                try{
                    let data={
                        role:this.role,
                        month:moment(this.GLOBAL.date).format('YYYY-MM'),
                        user_id:this.$store.getters.getUser.user_id,
                        tenant_id:this.$store.getters.getUser.tenant_id,
                        territory_id:this.GLOBAL.territory_id,
                    }
                    await http.post('/wapi/v1/getAllCount',data).then(res=>{
                        if(res.success){
                            let obj = res.data.obj
                            this.checkin=obj.checkin
                            this.checkin_gps=obj.checkin_gps
                            this.checkin_hand=obj.checkin_hand
                            if(this.checkin>0){
                                this.checkPercent=(this.checkin_gps/this.checkin)*100
                            }else{
                                this.checkPercent = 0
                            }
                            if(this.checkin==0){
                                let tag=document.getElementsByClassName('el-progress-bar__outer')
                                tag[0].style.backgroundColor="#909090"
                            }
                            this.inOut=obj.in_out
                            this.percentage=this.checkin==0?'0':((obj.in_out)/this.checkin*100).toFixed(0)
                            this.gridPercentage=this.percentage/10
                            this.in_field=obj.in_field==0?'0.0':(obj.in_field/1).toFixed(1)
                            // this.loading = false
                        }else {
                            this.loading = false
                        }

                    })
                }catch (e) {
                    this.loading = false
                }
            },
            handleSelectInputClick(){
                this.getCheckinCount()
                this.getSignInfo()
                this.getAllCount()
            },
            shelfData(){
                this.getCheckinCount()
                this.getSignInfo()
                this.getAllCount()
            },
            handleSelectInput(j){
                this.GLOBAL.date = j

            },
            ResetClick(){
                this.GLOBAL.date=''
            },
            exportDetailClick(){
                const loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try{
                    let data ={
                        user_id:this.$store.getters.getUser.user_id,
                        tenant_id:this.$store.getters.getUser.tenant_id,
                        role:this.$store.getters.getUser.role,
                        month:moment(this.GLOBAL.date).format('YYYY-MM'),
                        territory_id:this.GLOBAL.territory_id,
                    }
                    http.post('/wapi/v1/getSignDetail',data).then(res=>{
                        if(res.success){
                            this.array = res.data
                            this.exportClick1()
                            loading.close()
                        }
                    })
                }catch (e) {
                    loading.close()
                }

            },
            exportClick1(){

                try {
                    import('@/vendor/Export2Excel').then(excel => {
                        const tHeader = [ '签到日期', '客户编码', '客户名称','签入时间', '签入类型','签出时间','签出类型','创建人']
                        const filterVal = [
                            'checkin_date',
                            'reference_code',
                            'reference_name',
                            'checkin_time',
                            'retroactive',
                            'checkout_time',
                            'retroactiveout',
                            'alias',
                        ]
                        const list = this.array
                        const data = this.formatJson(filterVal, list)

                        excel.export_json_to_excel({
                            header: tHeader,
                            data,
                            filename: '签到报表明细',
                            autoWidth: this.autoWidth
                        })
                    })

                } catch (err) {

                    this.error()
                }
            },

            exportClick(){
                const loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {
                    import('@/vendor/Export2Excel').then(excel => {
                        let tHeader = []
                        let filterVal = []
                        if(this.isEndPoint){
                            tHeader = [ '辖区', '客户名称','签到次数', 'GPS签到次数', '手动签到次数','拜访总时长','平均拜访总时长']
                            filterVal = [
                                'territory_name',
                                'reference_name',
                                'checkin',
                                'checkin_gps',
                                'checkin_hand',
                                'visitTime',
                                'averageTime',
                            ]
                        }else {
                            tHeader = [ '下级辖区', '签到次数', 'GPS签到次数', '手动签到次数','拜访总时长','平均拜访总时长']
                            filterVal = [
                                'territory_name',
                                'checkin',
                                'checkin_gps',
                                'checkin_hand',
                                'visitTime',
                                'averageTime',
                            ]
                        }
                        const list = JSON.parse(JSON.stringify(this.tableData))
                        list.forEach(item=>{
                            let str = item.staff_name ? '('+item.staff_name+')':''
                            item.territory_name = item.territory_name + str
                        })
                        const data = this.formatJson(filterVal, list)

                        excel.export_json_to_excel({
                            header: tHeader,
                            data,
                            filename: '签到报表',
                            autoWidth: this.autoWidth
                        })
                    })
                    loading.close();
                } catch (err) {
                    loading.close();
                    this.error()
                }
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },
        },
        mounted() {
            this.getCheckinCount()
            this.getSignInfo()
            this.getAllCount()
            window.onresize = () => {
                this.scatterDom.resize()
            }
        },
        created() {
            if(this.GLOBAL.date){
                this.yearsDate = moment(this.GLOBAL.date).format('YYYY年M月')
            }else{
                this.yearsDate = moment().format('YYYY年M月')
            }
            this.role = this.$store.getters.getUser.role
        }
    }
</script>

<style scoped>
    #rate >>> .el-rate__icon{
        border-radius: 6px;
        overflow: hidden;
    }
    #rate >>> .el-rate__item{
        width: 22px;
    }
    #rate >>> .iconfont{
        font-size: 22px;
    }

</style>
<style>
    #progress .el-progress-bar__outer{
        background: #EF4F4F;
        border-radius: 2px;
    }
    #progress .el-progress-bar__inner{
        border-radius: 2px;
    }

</style>



// WEBPACK FOOTER //
// src/pages/statement/components/reception/index.vue